import { memo, ReactNode } from 'react';
import { MdInfo } from 'react-icons/md';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@cccom/ui/src/components/shadcn/tooltip';

type MoreInfoLabelProps = {
  label: string | ReactNode;
  tooltipLabel: string | ReactNode;
  tooltipIcon?: ReactNode;
};

export const MoreInfoLabel = memo(function MoreInfoLabel({
  label,
  tooltipLabel,
  tooltipIcon = <MdInfo />,
}: MoreInfoLabelProps) {
  return (
    <Tooltip>
      <div className="flex items-center gap-2">
        {typeof label === 'string' ? <p>{label}</p> : label}
        <TooltipTrigger asChild>
          {tooltipLabel && (
            <div
              data-testid="tooltip"
              className="text-lg leading-none text-gray-400"
            >
              {tooltipIcon}
            </div>
          )}
        </TooltipTrigger>
      </div>

      <TooltipContent>{tooltipLabel && <p>{tooltipLabel}</p>}</TooltipContent>
    </Tooltip>
  );
});
